import { Dispatch, SetStateAction } from 'react';

import { IntlFormatters } from 'react-intl';

import { IAppliedOffer, IOffersFragment } from 'generated/graphql-gateway';
import { IncentiveEvaluationMap } from 'state/loyalty/hooks/types';
import { ICart } from 'state/loyalty/in-restaurant-redemption';
import { LoyaltyOffer, LoyaltyOfferGroup } from 'state/loyalty/types';
import { ServiceMode } from 'state/service-mode/types';

export type ReduceOffers = ({
  cmsOffers,
  cmsOfferGroups,
  baseOffers,
  appliedOffers,
  inRestaurantRedemptionCart,
  checkLoyaltyOfferAvailability,
  getIncentiveUnavailableMessage,
  enableSortOffersForServiceMode,
  setOffersFeedbackMap,
  appliedFilters,
  selectedServiceMode,
  formatters,
}: {
  cmsOffers: LoyaltyOffer[];
  cmsOfferGroups: LoyaltyOfferGroup[];
  personalizedOffers: LoyaltyOffer[];
  baseOffers: IOffersFragment[];
  appliedOffers: IAppliedOffer[];
  inRestaurantRedemptionCart: ICart;
  checkLoyaltyOfferAvailability: (offer: LoyaltyOffer) => boolean;
  getIncentiveUnavailableMessage: (incentive: LoyaltyOffer) => string | undefined;
  enableSortOffersForServiceMode: boolean;
  setOffersFeedbackMap: Dispatch<SetStateAction<IncentiveEvaluationMap | null>>;
  appliedFilters: IOffersFilters;
  selectedServiceMode: ServiceMode | null;
  formatters: IntlFormatters;
}) => [LoyaltyOffer[], LoyaltyOffer[], LoyaltyOfferGroup[]];

export interface ILoyaltyOffersParams {
  offerEngineId?: string;
}

export enum OffersServiceMode {
  PICKUP_ONLY = 'pickUpOnly',
  DELIVERY_ONLY = 'deliveryOnly',
}

export enum OfferFiltersActionType {
  TOGGLE_PICKUP,
  TOGGLE_DELIVERY,
  TOGGLE_INSTORE,
  SELECT_PICKUP,
  SELECT_DELIVERY,
}

export type OfferFilterAction = {
  type: OfferFiltersActionType;
};

export interface IOffersFilters {
  [OffersServiceMode.PICKUP_ONLY]: boolean;
  [OffersServiceMode.DELIVERY_ONLY]: boolean;
  inStoreEnabled: boolean;
}
